export default __webpack_public_path__ + "slices/main/assets/public/media/capterra-logo.c87e91cb5374a4668fd3682cb3c1e71b.png";